import React, {useCallback, useContext, useMemo} from "react";
import "./marketplace-search-empty-search.css";
import SearchIcon from "../../images/searchIcon.svg";
import WhatsappIcon from "../../images/whatsappEmpty.svg";
import {SquareButton} from "../../components";
import {ContactPhone, ContactPhone as contactPhone} from "../../support/ContactPhone.jsx";
import {panelsOptions} from "../MarketplaceFilter/panel/consts.jsx";
import {StringBuilder} from "../../AppUtils.js";
import {getThemeByOrigin} from "../../utils.js";
import {AppContext} from "../../AppContext.jsx";

export const MarketplaceSearchEmptyResults = ({categories}) => {
    const {me, company} = useContext(AppContext);
    const categoriesToName = useMemo(
        () => panelsOptions.find(category => categories?.includes(category.key))?.text,
        [categories]
    );

    const onContactClick = useCallback(() => {
        contactPhone.openWhatsApp(
            ContactPhone.phoneNumber() || me?.assignedCSMs?.[0]?.phone || company?.assignedCSMs?.[0]?.phone
        );
    }, [me?.assignedCSMs, company?.assignedCSMs]);

    return (
        <div className="marketplace-search-empty-search">
            <img src={SearchIcon} alt={"searchIcon"} />
            <div className="marketplace-search-empty-text-container">
                <div>
                    <div className="title">
                        {categoriesToName
                            ? new StringBuilder()
                                  .append("לא נמצאו מוצרים לחיפוש שלך בקטגוריית")
                                  .append(categoriesToName)
                                  .toString()
                            : "לא נמצאו מוצרים לחיפוש שלך"}
                    </div>
                    <div className="description">ניתן לחפש בקטגוריה אחרת, או לדבר איתנו :)</div>
                </div>
                <SquareButton className="start-chat-btn" onClick={onContactClick}>
                    <img src={WhatsappIcon} alt={"whatsappIcon"} />
                    התחלת שיחה
                </SquareButton>
            </div>
        </div>
    );
};
